import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { pollingIntervalValidation } from 'src/utils/validationUtils';

const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
  <div className="form__form-group">
    <div className="form__form-group">
      <input
        {...input}
        placeholder={placeholder}
        type={type}
        disabled={disabled}  // Add the disabled prop here
      />
      {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </div>
);
const PollingIntervalConfig = ({ handleSubmit }) => {
  return (
    <Card>
      <CardBody>
        <Row>
          <Col md={12}>
            <h3 className="page-title">COM Server Configuration</h3>
          </Col>
        </Row>
       
      
        <form className="form-animated" onSubmit={handleSubmit}>
          <Col lg={6} md={6}>
            <Row>
              <Col lg={6} md={6}>
                <div className="form__form-group"><span className='required_field'>* </span>
                  <span className="form__form-group-label">COM Server IP</span>
                  <div className="form__form-group-field">
                    <Field
                      validate={required}
                      component={renderField}
                      name="comServerIpAddress"
                      type="text" placeholder="COM Server Port No."
                    />
                  </div>
                </div>
              </Col>

              <Col lg={6} md={6}>
                <div className="form__form-group"><span className='required_field'>* </span>
                  <span className="form__form-group-label">COM Server Port No.</span>
                  <div className="form__form-group-field">
                    <Field name="comServerPort" component={renderField} type="text" placeholder="COM Server Port No." validate={[pollingIntervalValidation, required]} />
                  </div>
                </div>

              </Col>
            </Row>
            <Row>
              <Col lg={6} md={6}>
                <div className="form__form-group"><span className='required_field'>* </span>
                  <span className="form__form-group-label">Active Polling Interval (in sec)</span>
                  <div className="form__form-group-field">
                    <Field name="activePollingInterval" component={renderField} type="text" placeholder="Active Polling Interval" validate={[pollingIntervalValidation, required]} />
                  </div>
                </div>
              </Col>
              <Col lg={6} md={6}>
                <div className="form__form-group"><span className='required_field'>* </span>
                  <span className="form__form-group-label">In-Active Polling Interval (in sec)</span>
                  <div className="form__form-group-field">
                    <Field name="inactivePollingInterval" component={renderField} type="text" placeholder="In-Active Polling Interval" validate={[pollingIntervalValidation, required]} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6} md={6}>
                <div className="form__form-group"><span className='required_field'>* </span>
                  <span className="form__form-group-label">ETA Polling Interval (in sec)</span>
                  <div className="form__form-group-field">
                    <Field name="etaPollingInterval" component={renderField} type="text" placeholder="ETA Polling Interval" validate={[pollingIntervalValidation, required]} />
                  </div>
                </div>
              </Col>
              <Col lg={6} md={6}>
                <div className="form__form-group"><span className='required_field'>* </span>
                  <span className="form__form-group-label">Delivery Polling Interval (in sec)</span>
                  <div className="form__form-group-field">
                    <Field name="deliveryPollingInterval" component={renderField} type="text" placeholder="Delivery Polling Interval" validate={[pollingIntervalValidation, required]} />
                  </div>
                </div>
              </Col>

            </Row>
            <Row>
              <Col lg={12} md={12}>
                <div className="form__OnboardingButton">
                  <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                    <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
                  </ButtonToolbar>
                </div>
              </Col>
            </Row>
          </Col>

        </form>
      </CardBody>
    </Card>


  );
};

PollingIntervalConfig.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, data) => {
  if (data && data.data) {
    return {
      initialValues: {
        inactivePollingInterval: data.data?.inactivePollingInterval,
        etaPollingInterval: data.data?.etaPollingInterval,
        deliveryPollingInterval: data.data?.deliveryPollingInterval,
        comServerPort: data.data?.comServerPort,
        comServerIpAddress: data.data?.comServerIpAddress,
        comServerConfigId: data.data?.comServerConfigId,
        activePollingInterval: data.data?.activePollingInterval,
      }
    }

  }
}

export default connect(mapStateToProps)(reduxForm({ form: 'PollingIntervalConfigForm', enableReinitialize: true })(PollingIntervalConfig))
